export const CACHE_KEY_FEEDBACK_SUBJECT_CREATE = 'feedback-subject-create';
export const CACHE_KEY_FEEDBACK_SUBJECT_UPDATE = 'feedback-subject-update';
